import moment from 'moment';
import { ICommentariesDataItem } from '../../types/layout/commentaries';
import CommentaryUserPhoto from './user-photo';

interface ICommentariesListProps {
    list: ICommentariesDataItem[];
}

const imgModal = `
<div class="modal image-view-modal" id="{ID_MASK}" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <button class="btn btn-link image-view-modal-close-btn" data-bs-dismiss="modal" type="button">
                <i class="fas fa-close nav-icon"></i>
            </button>
            <img src="{IMG_SRC}"></img>
        </div>
    </div>
</div>
`;

function CommentariesList({ list }: ICommentariesListProps) {
    const processCommentary = (text: string, commentaryIndex: number) => {
        if (text.includes('<img')) {
            const htmlDOM = document.createElement('div');
            htmlDOM.innerHTML = text;

            const images = htmlDOM.querySelectorAll('img');

            images.forEach((img, index) => {
                const modalId = `commentary-${commentaryIndex}-img-${index}`;

                img.setAttribute('data-bs-toggle', 'modal');
                img.setAttribute('data-bs-target', `#${modalId}`);

                const modal = document.createElement('div');
                modal.innerHTML = imgModal.replace('{ID_MASK}', modalId).replace('{IMG_SRC}', img.src);

                htmlDOM.append(modal);
            });

            return htmlDOM.innerHTML;
        }
        return text;
    };

    return (
        <div className="mt-4">
            {list.map((item, index) => (
                <div className="commentaries-list-item mb-4" key={index}>
                    <div className="d-flex flex-row">
                        <div className="mr-3">
                            <CommentaryUserPhoto name={item.user.name} photo={item.user.photo} />
                        </div>
                        <div className="d-flex flex-row flex-grow-1 justify-content-between">
                            <div className="mr-3">
                                <div className="mb-2">
                                    <b>{item.user.name}</b>
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: processCommentary(item.commentary, index) }} />
                            </div>
                            <div className="commentaries-list-item-date">
                                {moment(item.date).format('DD.MM.YYYY HH:mm')}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default CommentariesList;
